var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableRowHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86,16.57H21.14v2H2.86Zm0-7.11H21.14v5.08H2.86Zm0-4.06H21.14v2H2.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRowHeight);
export default __webpack_public_path__ + "static/media/table_row_height.978904a1b1f19b07ed227acedb23de7e.svg";
export { ForwardRef as ReactComponent };